const PubDateToOptions = {
	'+7DAY]': '1 Week',
	'+14DAY]': '2 Weeks',
	'+21DAY]': '3 Weeks',
	'+1MONTH]': '1 Month',
	'+2MONTH]': '2 Months',
	'+3MONTH]': '3 Months',
	'+4MONTH]': '4 Months',
	'+6MONTH]': '6 Months',
	'+9MONTH]': '9 Months',
	'+12MONTH]': '12 Months',
	'+18MONTH]': '18 Months',
};

export default PubDateToOptions;
